import { AccessScope } from '@dav-model/login/access-scopes.model';
import { createSelector } from '@ngrx/store';

import { State } from '../reducers';

export const selectUserState = (state: State) => state.userState;

export const selectUser = createSelector(selectUserState, (state) => state.user);
export const selectOriginalUser = createSelector(selectUserState, (state) => state.originalUser);
export const selectAllDealers = createSelector(selectOriginalUser, (user) => user.allDealers);
export const selectUserAccessScopes = createSelector(selectUserState, (state) => state.user?.scopes);
export const selectUserHasAccessScope = (scope: AccessScope) =>
  createSelector(selectUserAccessScopes, (scopes) => !!(scopes && scopes.includes(scope)));
export const selectCanEmulateDealer = createSelector(
  selectUserHasAccessScope('DEALER_EMULATE'),
  selectUserHasAccessScope('DEALER_EMULATE_ALL'),
  (emulate, emulateAll) => emulate || emulateAll
);
